import React from "react";
import "./App.css";
import RouteHandler from "./Routes";

function App(): JSX.Element {
  return <RouteHandler />;
}

export default App;
